import Client from '@/hexapla-core/client'
import { Domain } from '@/hexapla-core/domains'
import { Translator, TranslatorRelationship } from '@/hexapla-core/domains/resources'

export interface TranslatorService extends Domain<Translator> {
  index: (url: string) => Promise<Translator[]>
  show: (url: string, id: string | number) => Promise<Translator>
  create: (url: string, translator: Translator) => Promise<Translator>
  update: (url: string, translator: Translator) => Promise<Translator>
  destroy: (url: string, id: string | number) => Promise<void>
  relationships: (url: string) => Promise<TranslatorRelationship[]>
}

export const index = (url: string): Promise<Translator[]> =>
  Client.get<Translator[]>(`${url}/api/translators`)

// repeated as index in relationships.js
export const relationships = (url: string): Promise<TranslatorRelationship[]> =>
  Client.get<TranslatorRelationship[]>(`${url}/api/translators/relationships`)

export const show = (url: string, trID: string | number): Promise<Translator> =>
  Client.get<Translator>(`${url}/api/translators/${trID}`)

export const create = (url: string, translator: Translator): Promise<Translator> =>
  Client.post<Translator, Translator>(`${url}/api/translators`, translator)

export const update = (url: string, translator: Translator): Promise<Translator> =>
  Client.patch<Translator, Translator>(`${url}/api/translators/${translator.id}`, translator)

export const destroy = (url: string, trID: string | number): Promise<void> =>
  Client.destroy<void>(`${url}/api/admin/translators/${trID}`)

export default {
  index,
  show,
  create,
  update,
  destroy,
  relationships,
} as TranslatorService
